<template>
  <v-app id="login" class="primary">
    <v-main class="login">
      <v-container fluid class="px-12">
        <v-row>
          <v-col class="left" cols="7">
            <v-row>
              <v-col cols="12" class="logo">
                <v-img width="234px" src="@/assets/logo/m_logo.png" />
                <span class="white--text f-14"
                  >The ultimate finance planner apps</span
                >
              </v-col>
              <v-col>
                <div style="height: 60vh"></div>
              </v-col>
              <v-col cols="12" class="powered">
                <span class="white--text f-12"><b>Powered by:</b></span>
                <v-img
                  class="mt-5"
                  width="91px"
                  src="@/assets/logo/gits_logo.png"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="right" cols="5">
            <v-container
              fluid
              class="pa-0"
              :class="{ 'fill-height': $vuetify.breakpoint.smAndUp }"
            >
              <v-row align="center" justify="center">
                <v-col cols="12" xs="12" sm="10" md="10" lg="8">
                  <v-card class="mt-0 card-login" raised>
                    <ValidationObserver ref="obs">
                      <v-form @submit.prevent="login" class="form-login">
                        <!-- <v-alert
                          v-if="error && error.message"
                          class="ma-2"
                          type="error"
                          :value="true"
                          dismissible
                        >
                          {{ error.message }}
                        </v-alert> -->
                        <v-layout row wrap class="mb-6">
                          <v-flex xs12 class="px-3">
                            <h2
                              class="
                                white--text
                                text-left
                                mb-4
                                font-weight-bold
                                title
                              "
                            >
                              Welcome!
                            </h2>
                            <span class="subtitle">Create New Password</span>
                          </v-flex>
                        </v-layout>
                        <div>
                          <v-card-text class="pa-0">
                            <ValidationProvider
                              name="New Password"
                              vid="confirm"
                              rules="required|min:8"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                single-line
                                rounded
                                outlined
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show1 = !show1"
                                :type="show1 ? 'text' : 'password'"
                                name="New Password"
                                placeholder="New Password"
                                id="new-password"
                                v-model="new_password"
                                class="pa-0 text--white"
                                :error-messages="errors"
                                hint="At least 8 characters"
                                counter
                              />
                            </ValidationProvider>
                            <ValidationProvider
                              name="Confirm Password"
                              rules="required|confirmed:confirm|min:8"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                single-line
                                rounded
                                outlined
                                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show2 = !show2"
                                :type="show2 ? 'text' : 'password'"
                                name="Confirm Password"
                                placeholder="Confirm Password"
                                id="confirm-password"
                                v-model="confirm_password"
                                class="pa-0"
                                :error-messages="errors"
                                hint="At least 8 characters"
                                counter
                              />
                            </ValidationProvider>
                          </v-card-text>
                          <v-card-actions class="pa-0 mt-2 mb-3">
                            <v-flex xs12 class="pa-0">
                              <v-btn
                                id="btn-submit"
                                rounded
                                right
                                light
                                block
                                color="flatblue "
                                class="white--text"
                                :loading="loading2"
                                type="submit"
                                @click="submit"
                                height="44"
                                min-height="44"
                              >
                                Submit
                              </v-btn>
                            </v-flex>
                          </v-card-actions>
                        </div>
                      </v-form>
                    </ValidationObserver>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pt-3 copyright">
                  <h5 class="white--text font-weight-medium text-center f-12">
                    Copyright © 2022 GITS Indonesia.
                  </h5>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </v-app>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../components/progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog
  },
  props: ['token'],
  data: () => ({
    progressDialogLoading: false,
    isLogin: false,
    loading: false,
    loading2: false,
    loading3: false,
    new_password: '',
    confirm_password: '',
    email: '',
    password: '',
    formLogin: true,
    formProfile: false,
    checkbox: false,
    items: [],
    profile: null,
    show1: false,
    show2: false,
    formForgotPassword: false
  }),
  computed: {
    nextUri() {
      return this.$route.query.next || '/';
    }
  },
  mounted() {
    localStorage.clear();
  },
  methods: {
    async submit() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        // let body = {
        //   new_password: this.new_password,
        //   confirm_password: this.confirm_password
        // };
        let formData = new FormData();
        formData.append('new_password', this.new_password);
        formData.append('confirm_password', this.confirm_password);
        this.$store
          .dispatch('auth/createPassword', {
            token: this.token,
            params: formData
          })
          .then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            if (data.code === 200) {
              Swal.fire('Success!', data.message.text_en, 'success');
              this.$router.push({
                name: 'login'
              });
            } else {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            }
          })
          .catch(err => {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
            this.progressDialogLoading = false;
            this.loading = false;
          });
      }
    },
    backLogin() {
      this.formLogin = true;
      this.formProfile = false;
      this.formForgotPassword = false;
    },
    forgotPassword() {
      this.formForgotPassword = true;
      this.formProfile = false;
      this.formLogin = false;
    }
  }
};
</script>
<style scoped lang="scss">
.login {
  // height: 100%;
  // width: 100%;
  // position: absolute;
  background-image: url('../../assets/bg/bg_nav_core.png');
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  // top: 0;
  // left: 0;
  // content: '';
  // z-index: 0;
}
.powered span {
  opacity: 0.5;
}
.line {
  border: 1px solid #dadada;
}
.rememberme--text {
  color: red !important;
  font-size: 100px;
}
.card-login {
  background: transparent !important;
  box-shadow: none !important;
}
.card-login .form-login .title {
  font-size: 32px !important;
}
.card-login .form-login .subtitle {
  font-size: 18px !important;
  color: #8da6ff !important;
  font-weight: bold;
  line-height: 100%;
  letter-spacing: -0.02em;
}
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  height: 15px;
  left: 0;
  position: absolute;
  top: 0;
  width: 15px;
}

.round label:after {
  border: 2px solid #5273e8;
  border-top: none;
  border-right: none;
  content: '';
  height: 4px;
  left: 3px;
  opacity: 0;
  position: absolute;
  top: 4px;
  transform: rotate(-45deg);
  width: 7px;
}

.round input[type='checkbox'] {
  visibility: hidden;
}
.round input[type='checkbox']:checked + label {
  background-color: #fff;
  border-color: #ccd6e6;
}
.round input[type='checkbox']:checked + label:after {
  opacity: 1;
}
.copyright h5 {
  position: absolute;
  padding-top: 8%;
  right: 10.5%;
}
</style>
